import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RidersState } from "../../models/riders.model";

export const selectRidersState = createFeatureSelector<RidersState>('riders');


export const selectPagedRiders = createSelector(
    selectRidersState,
    (state: RidersState) => state.riders
);

export const selectTotalItems = createSelector(
    selectRidersState,
    (state: RidersState) => state.totalItems
);

export const selectTotalPages = createSelector(
    selectRidersState,
    (state: RidersState) => state.totalPages
);

export const selectRidersLocations = createSelector(
    selectRidersState,
    (state: RidersState) => state.ridersLocations
);

export const selectActiveRidersLocation = createSelector(
    selectRidersState,
    (state: RidersState) => state.activeRiderLocations
);

export const selectInactiveRidersLocation = createSelector(
    selectRidersState,
    (state: RidersState) => state.inactiveRiderLocations
);

export const selectBusyRidersLocation = createSelector(
    selectRidersState,
    (state: RidersState) => state.busyRiderLocations
);

export const selectSearchedRiders = createSelector(
    selectRidersState,
    (state: RidersState) => state.searchedRiders
);

export const selectRider = createSelector(
    selectRidersState,
    (state: RidersState) => state.rider
);

export const selectIsLoading = createSelector(
    selectRidersState,
    (state: RidersState) => state.loading
);

export const selectRiderById = () => createSelector( 
    selectRidersState,
    (state: RidersState) => state.rider
);